import { render } from "./ShippingAddresses.vue?vue&type=template&id=8b80be6c"
import script from "./ShippingAddresses.vue?vue&type=script&setup=true&lang=js"
export * from "./ShippingAddresses.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/ShippingAddresses.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b80be6c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b80be6c', __exports__)) {
    api.reload('8b80be6c', __exports__)
  }
  
  module.hot.accept("./ShippingAddresses.vue?vue&type=template&id=8b80be6c", () => {
    api.rerender('8b80be6c', render)
  })

}


export default __exports__